import Colors from '../../../../../constants/Colors';

export default {
  container: {
    flex: 1,
    flexDirection: 'column',
    marginBottom: 8,
  },
  title: {
    fontSize: 14,
    color: Colors.grayText,
    textTransform: 'capitalize',
  },
  inputContainer: {
    border: `1px solid ${Colors.lightGray}`,
    borderRadius: 6,
    padding: 4,
    color: Colors.darkText,
  },
  inputContainerError: {
    border: `1px solid ${Colors.lightGray}`,
    boxShadow: `0.5px 1px 6px ${Colors.red}`,
  },
  inputContainerFieldUnavailable: {
    border: `1px solid ${Colors.lightGray}`,
    boxShadow: `0.5px 1px 6px ${Colors.yellowHotelNoIntegratedText}`,
  },
  pmsValueContainer : {
    color: Colors.red,
  },
  pmsFieldUnavailableContainer : {
    color: Colors.yellowHotelNoIntegratedText,
  }, 
};
